
import { motion } from 'framer-motion';

const ProgramOverview = () => {
  const features = [
    {
      icon: 'ri-user-star-line',
      title: 'Who This Is For',
      description: 'Career changers, junior PMs, and aspiring leaders ready to accelerate their project management journey with expert guidance and proven frameworks.',
    },
    {
      icon: 'ri-trophy-line',
      title: 'What You\'ll Gain',
      description: 'Personalized mentorship, real-world frameworks, increased confidence, career clarity, and the skills to lead high-impact projects with precision.',
    },
    {
      icon: 'ri-focus-3-line',
      title: 'Program Focus',
      description: 'PM fundamentals, leadership development, delivery frameworks, industry-standard tools, and strategic career planning for long-term success.',
    },
  ];

  return (
    <section className="py-24 lg:py-32 bg-ivory">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-playfair text-4xl lg:text-5xl font-semibold text-charcoal mb-6">
            Transform Your <em className="text-warm-gold">PM Career</em>
          </h2>
          <p className="font-inter text-lg text-charcoal/60 max-w-3xl mx-auto">
            PM Launchpad is a comprehensive mentorship program designed to accelerate your growth as a project manager through structured guidance, proven methodologies, and personalized support.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-warm-white rounded-2xl p-10 shadow-md hover:shadow-xl transition-all duration-300"
            >
              <div className="w-16 h-16 bg-warm-gold/20 rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-warm-gold`}></i>
              </div>
              <h3 className="font-inter text-xl font-bold text-charcoal mb-4">
                {feature.title}
              </h3>
              <p className="font-inter text-base text-charcoal/70 leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgramOverview;
